module.exports = __webpack_public_path__ + "img/capacidad.a0f74098.svg";